import React, { Component } from 'react';
import CreditDetailsArticle, { CREDIT_DETAILS_TEMPLATE } from './CreditDetailsArticle';
import CreditDetailsContainer from './CreditDetailsContainer';

export default {
    Article: CreditDetailsArticle,
    Container: CreditDetailsContainer,
    TEMPLATE: CREDIT_DETAILS_TEMPLATE
};
